module.exports = __webpack_public_path__ + "static/media/youtube-white.e8799666.svg";